module.exports = __webpack_public_path__ + "static/media/alarm-plus.b3e42ccb.svg";